/**
 * DOS518 — Integrazione ASTUTO (CFRS Sicilia)
 * Copyright (c) 2024-2025 Angelo Irtilaç — All rights reserved.
 *
 * types.ts — Tipi condivisi per tutta la catena di integrazione.
 * Nessun import dall'app — pura definizione di forme dati.
 */

// ── Modalità di connessione ──────────────────────────────────────────────────

export type AstutoMode = 'rest' | 'file' | 'clipboard' | 'disabled';

// ── Configurazione (salvata su localStorage) ────────────────────────────────

export interface AstutoConfig {
  mode: AstutoMode;
  // REST
  restBaseUrl?: string;       // es. "https://astuto.cfrs.it/api/v1"
  restApiKey?: string;        // Bearer token o API key
  restTimeoutMs?: number;     // default 8000
  // Metadati
  lastUsed?: string;          // ISO — ultimo import riuscito
}

// ── Rappresentazione neutra dei dati ASTUTO ─────────────────────────────────

export interface AstutoIntervento {
  codice?: string;
  data?: string;
  ora?: string;
  comune?: string;
  localita?: string;
  latitudine?: string;
  longitudine?: string;
  personale: AstutoPersona[];
  mezziTerrestri: AstutoMezzo[];
  mezziAerei: AstutoMezzoAereo[];
}

export interface AstutoPersona {
  matricola?: string;
  nome: string;
  cognome: string;
  qualifica?: string;
  telefono?: string;
  radio?: string;
  ente?: string;
}

export interface AstutoMezzo {
  sigla: string;
  tipo?: string;
  targa?: string;
  ente?: string;
}

export interface AstutoMezzoAereo {
  sigla: string;
  tipo?: string;
  modello?: string;
}

// ── Risultato restituito da ogni adapter ────────────────────────────────────

export type AstutoResult =
  | { ok: true;  data: AstutoIntervento }
  | { ok: false; error: string };

// ── Opzioni di importazione ──────────────────────────────────────────────────

export interface ImportOptions {
  importaPersonale: boolean;
  importaMezziTerrestri: boolean;
  importaMezziAerei: boolean;
  importaCoordinate: boolean;
  importaCOAU: boolean;
  svuotaEsistenti: boolean;
}

export const DEFAULT_IMPORT_OPTIONS: ImportOptions = {
  importaPersonale: true,
  importaMezziTerrestri: true,
  importaMezziAerei: true,
  importaCoordinate: true,
  importaCOAU: true,
  svuotaEsistenti: false,
};
